// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38D6b","colBig":"styles_colBig__146IB","colSmall":"styles_colSmall__lCm0k","shopifyNameWrapper":"styles_shopifyNameWrapper__2h-vd"};